import React, { useState } from 'react';

import { Typography, ButtonIcon } from '@hpstellar/core/visId';
import { Share } from '@hpstellar/vis-icons';

import withPageComponents from '../../../page/components/with-page-components';
import AdaptiveImage from '../../../shared/components/adaptive-image';
import ShareConfig from '../../components/share-config';
import useSpecsSelected from '../../components/configure-options/useSelectedSpecs';
import SavingsProgressBar from '../../components/savings-progress-bar';
import { Helpers } from '../../../core/src/helpers';

import './current-config.less';

function CurrentConfig({ baseConfig, innerWidth, ctoSettings, configLabel = 'Your configuration' }) {
    if (!baseConfig) {
        return null;
    }

    const { image, alternateImage, ULList } = baseConfig;
    const { disableFPS } = ctoSettings || {};
    const hasFPS = !disableFPS && Object.keys(ULList || {}).length > 0;
    const specs = useSpecsSelected({ label: true });

    const [modalOpen, setModalOpen] = useState(-1);

    const mobile = innerWidth < 768;

    return (
        <div className="configure-v2-config" style={{ top: hasFPS ? '180px' : '75px' }}>
            <div className="current-config">
                {image && (
                    <AdaptiveImage
                        className="current-config-image"
                        src={Helpers.purifyUrl(alternateImage || image)}
                        maxWidth={573}
                        prefetch={true}
                    />
                )}
                {!mobile && <SavingsProgressBar v2 />}
                <div className="current-config-content">
                    <div className="current-config-title">
                        <Typography variant="body1" weight={700}>
                            {configLabel}
                        </Typography>
                        <ButtonIcon
                            className="current-config-share"
                            onClick={() => setModalOpen(1)}
                            tabIndex={0}
                            icon={<Share />}
                            hasBorder={false}
                            size="large"
                        />
                    </div>
                    <div className="current-config-specs">
                        {specs.map((spec, index) => (
                            <React.Fragment key={spec.label + index}>
                                <Typography className="current-config-specs-label">{spec.label}</Typography>
                                <Typography className="current-config-specs-value">{spec.value}</Typography>
                            </React.Fragment>
                        ))}
                    </div>
                </div>
                {modalOpen >= 0 && <ShareConfig isOpen={modalOpen} onModalClose={() => setModalOpen(0)} />}
            </div>
        </div>
    );
}

export default withPageComponents(CurrentConfig, {
    components: ['baseConfig', 'ctoProductInitial', 'ctoPrice', 'shipDate', 'froggerMessage', 'ctoSettings'],
    device: true,
});
